import Layer from './Layer';

// 地理院地図 陰影起伏図
export default class HillShadeMap extends Layer {
    url = 'https://cyberjapandata.gsi.go.jp/xyz/hillshademap/{z}/{x}/{y}.png';

    constructor() {
        const id = 'hillshademap';
        const layers = {
            'hillshademap-raster': {
                type: "raster",
                source: id,
            },
        };

        const paintOptions = {
            'hillshademap-raster': {
                "raster-brightness-max": 0.24,
                "raster-opacity": 0.4,
            },
        };

        // レイヤー要素。この単位でレイヤリングする。配列順に最前面→再後面
        const elements = [
            { id: 'hillshademap', layers: ['hillshademap-raster'], isShow: true },
        ];

        super(id, layers, paintOptions, elements);
    }

    // レイヤーは時刻を持たないのでオーバーライドして null 値をセットする。
    set datetime(datetime) { super.datetime = null; }
    get datetime() { return super.datetime; }

    async add() {
        this.map.addSource(this.id, {
            "type": "raster",
            "minzoom": 2,
            "maxzoom": 16,
            "tilesize": 256,
            "tiles": [this.url]
        });

        Object.keys(this.layers)
            .map(x =>
                this.map.addLayer({ id: x, ...this.layers[x], paint: { ...this._paintOptions[x] } })
            );
    }

    remove() {
        Object.keys(this.layers)
            .map(x => this.map.removeLayer(x));

        this.map.removeSource(this.id);
    }
};


